var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a4",staticStyle:{"padding":"80px 80px","box-sizing":"border-box"}})
}
var staticRenderFns = []

export { render, staticRenderFns }